import { Client } from './clientTypes';

export const atsIntegrations: Client[] = [
  { 
    id: 49, 
    name: "MyJobHelper", 
    logoPath: "/lovable-uploads/bd0413d1-d948-4cf2-ac79-dc752bf83679.png",
    altText: "Logo de MyJobHelper" 
  },
  { 
    id: 50, 
    name: "Recruit.net", 
    logoPath: "/lovable-uploads/a5546e58-a4d7-459c-8dd4-6bbead262fa6.png",
    altText: "Logo de Recruit.net" 
  },
  { 
    id: 51, 
    name: "GrabJobs", 
    logoPath: "/lovable-uploads/33cb2b7b-bebd-4423-b9a3-a19fceebff63.png",
    altText: "Logo de GrabJobs" 
  },
  { 
    id: 52, 
    name: "WhatJobs", 
    logoPath: "/lovable-uploads/35f1431d-92d7-4667-9020-2385a532689a.png",
    altText: "Logo de WhatJobs" 
  },
  { 
    id: 53, 
    name: "Upward", 
    logoPath: "/lovable-uploads/a4976447-4df9-4247-8b5f-165aa5ea1424.png",
    altText: "Logo de Upward" 
  },
  { 
    id: 54, 
    name: "Talent.com", 
    logoPath: "/lovable-uploads/aca9a338-1619-465f-884b-8507eaad1c53.png",
    altText: "Logo de Talent.com" 
  },
  { 
    id: 55, 
    name: "Jora", 
    logoPath: "/lovable-uploads/b0ca7371-a110-495b-8f09-45222f6d99c3.png",
    altText: "Logo de Jora" 
  },
  { 
    id: 56, 
    name: "Jobrapido", 
    logoPath: "/lovable-uploads/8c1c5e9b-7f98-4a49-8459-f173ea6db3c8.png",
    altText: "Logo de Jobrapido" 
  },
  { 
    id: 57, 
    name: "Job is Job", 
    logoPath: "/lovable-uploads/266529ec-196f-4276-b27d-fac38498ae89.png",
    altText: "Logo de Job is Job" 
  },
  { 
    id: 58, 
    name: "CareerJet", 
    logoPath: "/lovable-uploads/8a18712e-92ab-4669-8db3-55be9255c42f.png",
    altText: "Logo de CareerJet" 
  },
  { 
    id: 59, 
    name: "Zapier", 
    logoPath: "/lovable-uploads/02e1506a-916b-4c61-a076-b9b25182f34e.png",
    altText: "Logo de Zapier" 
  },
  { 
    id: 60, 
    name: "Slack", 
    logoPath: "/lovable-uploads/0659e543-9164-4d97-968d-efafe1f75ad9.png",
    altText: "Logo de Slack" 
  },
  { 
    id: 61, 
    name: "Glassdoor", 
    logoPath: "/lovable-uploads/b47d77b3-d84b-43ea-a25e-9cd41d0374c2.png",
    altText: "Logo de Glassdoor" 
  },
  { 
    id: 62, 
    name: "Monster", 
    logoPath: "/lovable-uploads/4f300525-b63f-4bea-86ab-ff114ec338f0.png",
    altText: "Logo de Monster" 
  },
  { 
    id: 63, 
    name: "Google", 
    logoPath: "/lovable-uploads/61630447-9d34-447f-9b3b-d38ebf8128f5.png",
    altText: "Logo de Google" 
  },
  { 
    id: 64, 
    name: "Indeed", 
    logoPath: "/lovable-uploads/4fa0537b-c8b6-4205-8a3d-79358f9ac1b0.png",
    altText: "Logo de Indeed" 
  },
  { 
    id: 65, 
    name: "LinkedIn", 
    logoPath: "/lovable-uploads/6ccd7bbe-2b2f-4013-a2d6-0ffb26367521.png",
    altText: "Logo de LinkedIn" 
  },
  { 
    id: 66, 
    name: "ZipRecruiter", 
    logoPath: "/lovable-uploads/87cb4796-01ff-492f-a8b3-1574f23123c9.png",
    altText: "Logo de ZipRecruiter" 
  },
  { 
    id: 67, 
    name: "Adzuna", 
    logoPath: "/lovable-uploads/75dc81cc-0bd0-488d-a061-787bc9064f1b.png",
    altText: "Logo de Adzuna" 
  },
  { 
    id: 68, 
    name: "Jobtome", 
    logoPath: "/lovable-uploads/686b830f-abb3-46f1-ab40-1abd8c1929cb.png",
    altText: "Logo de Jobtome" 
  },
  { 
    id: 69, 
    name: "Jooble", 
    logoPath: "/lovable-uploads/22b3e313-b107-453e-b1fd-b60fb0316571.png",
    altText: "Logo de Jooble" 
  },
  { 
    id: 70, 
    name: "Welcome to the Jungle", 
    logoPath: "/lovable-uploads/ae8e23bf-f2e8-4ae6-87e1-a59a76cfa960.png",
    altText: "Logo de Welcome to the Jungle" 
  },
];